<template>
  <div>
    <el-upload
      class="upload-card"
      drag
      action="wwm"
      multiple
      :show-file-list="false"
      :http-request="uploadSectionFile"
    >
      <el-button type="primary">上传文件</el-button>
      <span>点击或将文件拖拽到这里上传</span>
      <span>支持拓展名：.rar .zip .doc .docx .pdf .jpg...</span>
    </el-upload>
    <!-- <div class="upload">
      <div class="hd">
        <h4>
          已上传资料<em>{{ data.length }}份</em>
        </h4>
        <span></span>
      </div>
      <div class="bd">
        <ul>
          <li v-for="(d, i) in data" :key="'upload' + i">
            <span class="sn">{{ i + 1 }}</span
            ><em>*</em><span class="title">标题</span
            ><el-input
              placeholder="请输入内容"
              v-model="d.resourceName"
              style="width: 450px"
              size="small"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <span class="suffix">{{ d.type }}</span>
            <el-button type="text">删除</el-button>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
import upload from "../../mixins/upload";
export default {
  data() {
    return {
      active: "1",
      data: [],
      categoryData: [],
      breadcrumb: [],
      breadcrumbData: {
        section: "",
      },
      activeName: "",
      sectionData: [],
      init: 0,
    };
  },
  mixins: [upload],
  props: {
    id: {
      default: "",
    },
  },
  methods: {
    save() {},
    async uploadSectionFile(params) {
      let file = await this.upload(params);
      this.data.push({
        thematicTypeId: this.id,
        resourceSource: 1,
        resourceName: file.name,
        fileType: file.fileType,
        type: file.type,
        fileUrl: file.url,
        fileSize: file.size,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/special/upload3.vue